module.exports = __webpack_public_path__ + "static/media/printer-line.dfa8ff11.svg";